import React from 'react'
import adelaideCrows from './assets/adelaide-crows-ade.svg'
import brisbaneLions from './assets/brisbane-lions-bri.svg'
import carltonBlues from './assets/carlton-blues-car.svg'
import collingwoodMagpies from './assets/collingwood-magpies-col.svg'
import essendonBombers from './assets/essendon-bombers-ess.svg'
import fremantleDockers from './assets/fremantle-dockers-fre.svg'
import goldcoastSuns from './assets/goldcoast-suns-gcs.svg'
import gwsGiants from './assets/gws-giants-gws.svg'
import hawthornHawks from './assets/hawthorn-hawks-haw.svg'
import melbourneDemons from './assets/melbourne-demons-mel.svg'
import northMelbourneKangaroos from './assets/north-melbourne-kangaroos-nor.svg'
import portAdelaidePower from './assets/port-adelaide-power-por.svg'
import richmondTigers from './assets/richmond-tigers-ric.svg'
import stkildaSaints from './assets/stkilda-saints-stk.svg'
import sydneySwans from './assets/sydney-swans-syd.svg'
import westCoastEagles from './assets/west-coast-eagles-wce.svg'
import westernBulldogs from './assets/western-bulldogs-bul.svg'
import geelongCat from './assets/geelong-cats-gee.svg'

export const AFLTeamIcon: React.FC<{
  participationId: number
}> = ({ participationId }) => {
  const iconName = kambiSportTeamToIconMap[participationId]
  if (!iconName) {
    return null
  }

  return <img height={32} width={32} src={iconName} />
}

// =============
// Local Helpers
// =============

const kambiSportTeamToIconMap: Partial<Record<number, string>> = {
  1000780164: adelaideCrows,
  1000780165: adelaideCrows,
  1003770531: adelaideCrows,
  1000780158: brisbaneLions,
  1003770533: brisbaneLions,
  1000780149: carltonBlues,
  1003545914: carltonBlues,
  1000780167: collingwoodMagpies,
  1003545913: collingwoodMagpies,
  1000780151: essendonBombers,
  1028303749: essendonBombers,
  1002858875: fremantleDockers,
  1003545911: fremantleDockers,
  1000780150: geelongCat,
  1005215339: geelongCat,
  1000966935: goldcoastSuns,
  1005953609: goldcoastSuns,
  1001211246: gwsGiants,
  1003545915: gwsGiants,
  1000780157: hawthornHawks,
  1028303752: hawthornHawks,
  1000780156: melbourneDemons,
  1003545909: melbourneDemons,
  1000780163: northMelbourneKangaroos,
  1005215340: northMelbourneKangaroos,
  1000780162: portAdelaidePower,
  1028303754: portAdelaidePower,
  1000780148: richmondTigers,
  1005953611: richmondTigers,
  1000780161: stkildaSaints,
  1005953610: stkildaSaints,
  1000780160: sydneySwans,
  1028303755: sydneySwans,
  1000780159: westCoastEagles,
  1005953608: westCoastEagles,
  1000780166: westernBulldogs,
  1003545910: westernBulldogs,
}
